// extracted by mini-css-extract-plugin
module.exports = {"InputError":"style_InputError__21MaI","wrapper":"style_wrapper__3-NcW","error":"style_error__3r9-T"};